import React from 'react'
import { flowRight } from 'lodash'
import { useTranslation } from 'react-i18next'
import { withErrorBoundary } from 'lib/errorBoundary'
import { getAlmaLogo } from 'lib/images'
import useCurrentUser from 'lib/hooks/useCurrentUser'
import { ALMA_AUTH0_CLIENT_ID, almaForgottenPasswordURI } from 'lib/alma/alma'

import Link from 'components/Link'

import './user-edit-info.pcss'

const UserEditInfo = () => {
    const currentUser = useCurrentUser()

    const user = currentUser.me.user

    const { t } = useTranslation('editProfile')

    return (
        <div className="user-edit-info">
            <div className="user-edit-info__head">
                <h2 className="user-edit-info__title">{t('editProfile:header.title')}</h2>
                <div className="user-edit-info__logo">
                    {getAlmaLogo()}
                </div>
            </div>
            <div className="user-edit-info__body">
                <div>{user.firstName} {user.lastName}</div>
                <div>{user.email}</div>
                <div className="user-edit-info__bottom">
                    <div className="user-edit-info__bottom-left">
                        <Link
                            to={`${almaForgottenPasswordURI}?clientId=${ALMA_AUTH0_CLIENT_ID}&email=${user.email}`}
                            className="button button--tertiary"
                            title={t('editProfile:header.resetPassword')}
                            trackName="resetPassword"
                        >
                            {t('editProfile:header.resetPassword')}
                        </Link>
                    </div>
                    <div className="user-edit-info__bottom-right">
                        <Link
                            to="https://itsepalvelu.almamedia.fi"
                            className="button button--tertiary"
                            title={t('editProfile:header.editAccount')}
                            trackName="editAccount"
                        >
                            {t('editProfile:header.editAccount')}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default flowRight(
    withErrorBoundary,
)(UserEditInfo)
